module.exports = __webpack_public_path__ + "img/icon-checkmark-teal.318a345f.svg";